import { Action, createReducer, on } from '@ngrx/store';
import {
  CERTIFICA_CELLULARE,
  CERTIFICA_CELLULARE_SUCCESS,
  CERTIFICA_CELLULARE_FAIL,
  CERTIFICA_CELLULARE_RESET,
  CERTIFICA_CELLULARE_OTP,
  CERTIFICA_CELLULARE_OTP_SUCCESS,
  CERTIFICA_CELLULARE_OTP_FAIL,
} from './certifica-cellulare.actions';
import { ICertificaCellulareState } from './certifica-cellulare';

const initialState: ICertificaCellulareState = {
  esito: null,
  loading: false,
  seed: null,
  cellulare: null,
  username: null,
  error: null,
  otpTtlSeconds: 300,
  msgCode: null,
  maxTentativi: 5,
};

const reducerBase = createReducer(
  initialState,

  on(CERTIFICA_CELLULARE, (state) => ({
    ...state,
    loading: true,
    esito: null,
    error: null,
    msgCode: null,
  })),

  on(CERTIFICA_CELLULARE_SUCCESS, (state, { esito, seed, cellulare, otpTtlSeconds, msgCode, maxTentativi }) => ({
    ...state,
    esito,
    seed,
    cellulare,
    loading: false,
    error: null,
    otpTtlSeconds: otpTtlSeconds ?? state.otpTtlSeconds,
    msgCode: msgCode ?? null,
    maxTentativi: maxTentativi ?? state.maxTentativi,
  })),

  on(CERTIFICA_CELLULARE_FAIL, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CERTIFICA_CELLULARE_OTP, (state) => ({
    ...state,
    loading: true,
    esito: null,
    error: null,
    msgCode: null,
  })),

  on(CERTIFICA_CELLULARE_OTP_SUCCESS, (state, { esito, username, msgCode }) => ({
    ...state,
    loading: false,
    esito,
    username,
    error: null,
    msgCode: msgCode ?? null,
  })),

  on(CERTIFICA_CELLULARE_OTP_FAIL, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CERTIFICA_CELLULARE_RESET, () => initialState)
);

export function certificaCellulareReducer(
  state: ICertificaCellulareState | undefined,
  action: Action
): ICertificaCellulareState {
  return reducerBase(state, action);
}
